/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const USER_SERVICE = {
    login,
    updatePassword,
    requestLink,
    resetPassword,
    logout,
    getUsers,
    putUserChangeStatus,
    getUserById,
    deleteUser,
    refreshToken
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Users";

/* Services */
function login(username, password) 
{
    // Mandatory parameters
    if(!username || !password)
    {
        return Promise.reject("The parameters are not complete!");
    }

    //

    var raw = JSON.stringify({username, password});

    const requestOptions = {
        method: 'POST',
        headers: {"Content-Type":"application/json"},
        body: raw
    };

    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Login"]);

    return processLogin(url, requestOptions);
}

function updatePassword(password) 
{
    // Mandatory parameters
    if(!password)
    {
        return Promise.reject("The parameters are not complete!");
    }

    //

    const requestOptions = {
        method: 'PUT',
        headers: {...authHeader(), "Content-Type":"application/json" },
        body: `"${password}"`
    };

    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Password"]);

    return API_HELPER.loggedApiCall(url, null, requestOptions);    
}

function requestLink(email) 
{
    // Mandatory parameters
    if(!email)
    {
        return Promise.reject("The parameters are not complete!");
    }

    //

    const requestOptions = {
        method: 'GET',
    };

    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Reset", email]);

    return API_HELPER.apiCall(url, null, requestOptions);
}

function resetPassword(username, password, token) 
{
    // Mandatory parameters
    if(!username || !password || !token)
    {
        return Promise.reject("The parameters are not complete!");
    }

    //

    var raw = JSON.stringify({username, password, token});
    const requestOptions = {
        method: 'PUT',
        headers: { "Content-Type":"application/json" },
        body: raw
    };

    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Reset"]);

    return API_HELPER.apiCall(url, null, requestOptions);    
}

function processLogin(url, requestOptions)
{
    return fetch(encodeURI(url), requestOptions)
    .then(response =>{
        if(ENVIRONMENT_HELPER.isDev()) console.log(response);

        return response.text().then(text => {
            const data = text && JSON.parse(text);

            if (!response.ok) {
                return Promise.reject(data.message);
            }
    
            return data;
        });        
    })
    .then(data => {
        var user = data;

          // login successful if there's a jwt token in the response
        if (user.data.accessToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }
  
        return user;
    })
    .catch(error=> {
        var errorMsg;

        if(typeof error != 'string')
        {
            if(ENVIRONMENT_HELPER.isProd())
            {
                errorMsg = "Something went wrong, please try again. If the problem persists contact the support.";
            }
            else
            {
                errorMsg = error.toString();
            }
        }
        else
        {
            errorMsg = error;
        }

        return Promise.reject(errorMsg);
    });
}

function logout() {
    // TODO Integrate logout service
    return true;
}

//Service to get users
function getUsers(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

//Service to update status
function putUserChangeStatus(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "status"]);

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get static info details
function getUserById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

//Service to remove users
function deleteUser(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, input.id]);

    const description = JSON.stringify(input.description);

    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: description
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function refreshToken(token, username)
{
    // Mandatory parameters
    if(!token || !username)
    {
        return Promise.reject("The parameters are not complete!");
    }

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({token, username})
    };

    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "RefreshToken"]);

    return API_HELPER.apiCall(url, null, requestOptions);
}
